import ThreeColumnRepository from "../ThreeColumnRepository"

export default class FeatureThreeColumn extends ThreeColumnRepository {
    static schemaId = "feature_threeColumn1"

    constructor() {
        super(FeatureThreeColumn.schemaId)
    }
}
